import { useMemo } from "react";
import { notEqualValues, required } from "../../../../../../helpers/forms/validate.js";
import useValue from "../../../../../../hooks/forms/useValue.js";
import { useSearcherFlightHotelProps, useSearcherFlightHotelState } from "../../context/index.js";
import useDestinationInput from "../destination-input/useDestinationInput.js";
import useOriginInput from "../origin-input/useOriginInput.js";
const useLocationInput = ()=>{
    const props = useSearcherFlightHotelProps();
    const { config  } = props ?? {};
    const { literals  } = config ?? {};
    const state = useSearcherFlightHotelState();
    const { destinationAirport  } = state ?? {};
    const originInput = useOriginInput();
    const destinationInput = useDestinationInput();
    const originValue = useValue({
        name: 'origin'
    });
    const requiredValidation = useMemo(()=>[
            required()
        ], []);
    const originDestinationNotEqualValidation = useMemo(()=>[
            required(),
            notEqualValues(originValue?.value, destinationAirport?.code)
        ], [
        destinationAirport?.code,
        originValue?.value
    ]);
    return useMemo(()=>({
            literals,
            origin: originInput,
            destination: destinationInput,
            originValidate: requiredValidation,
            destinationValidate: originDestinationNotEqualValidation
        }), [
        destinationInput,
        literals,
        originDestinationNotEqualValidation,
        originInput,
        requiredValidation
    ]);
};
export default useLocationInput;

//# sourceMappingURL=useLocationInput.js.map